import React, { useEffect } from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { Dialog, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { ScoresheetProvider } from '../scoresheet/ScoresheetContext';
import { LazyBoundary } from '../../common/LazyBoundary';
import DialogTitleWithActions from '../../common/dialogs/DialogTitleWithActions';

const LineupCardBody = React.lazy(() => import('../scoresheet/lineup/LineupCard'))


const DialogHeader = ({ game, onClose }) => {
  const translate = useTranslate();

  return <DialogTitleWithActions onClose={onClose}>
    {translate('resources.games.labels.game_number_lineup', { number: game.number })}
  </DialogTitleWithActions>
}

export default ({ open, teamId, onClose }) => {
  const game = useRecordContext()
  const history = useHistory();
  const fullScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  useEffect(() => {
    return history.listen(() => {
      if (!open) return;
      onClose();
    })
  }, [history, onClose, open])

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  }

  if (!game) return null;

  const onClick = e => e.stopPropagation();
  return <Dialog
    open={open}
    fullWidth
    fullScreen={fullScreen}
    maxWidth="sm"
    onClick={onClick}
    onClose={handleClose}
  >
    <DialogHeader game={game} onClose={onClose} />
    <LazyBoundary>
      <ScoresheetProvider gameId={game.id}>
        <LineupCardBody teamId={teamId} showCompleted />
      </ScoresheetProvider>
    </LazyBoundary>
  </Dialog>
}
